import React from "react";
import { useNavigate } from "react-router-dom";

import { getActivityVizApiBase } from "../services/ActivityVizApi";
import { authDebug } from "../services/AuthDebug";
import { AuthService, hasPersistedUser } from "../services/AuthService";
import { getStravaAuthUrl, getStravaRedirectUri } from "../services/StravaAuth";
import stravaLoginButton from "../svg/btn_strava_connectwith_orange.svg";
import { BrandLogo } from "./brand/BrandLogo";

export function PublicHome() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const isAuthenticated = AuthService.isAuthenticated();
    const persistedUser = hasPersistedUser();
    authDebug("public_home.effect", {
      apiBase: getActivityVizApiBase(),
      redirectUri: getStravaRedirectUri(),
      isAuthenticated,
      persistedUser,
      auth: AuthService.getSnapshot(),
    });

    if (isAuthenticated && persistedUser) {
      authDebug("public_home.redirect.dashboard");
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-[var(--color-surface-canvas)] text-[var(--color-content-primary)]">
      <main className="relative mx-auto flex min-h-screen w-full max-w-5xl flex-1 flex-col items-center justify-center px-6 py-12 text-center">
        <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
          <div className="absolute left-1/2 top-20 h-72 w-72 -translate-x-[140%] rounded-full bg-[var(--color-hero-glow)] blur-3xl" />
          <div className="absolute right-1/2 top-36 h-80 w-80 translate-x-[140%] rounded-full bg-[var(--color-hero-glow)] blur-3xl" />
          <div className="absolute bottom-12 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-[var(--color-hero-glow)] blur-3xl" />
        </div>
        <BrandLogo
          className="mb-8"
          markClassName="h-20 w-20 sm:h-24 sm:w-24"
          textClassName="text-left sm:text-center"
          showTagline
          stacked
        />
        <h1 className="mb-4 max-w-4xl font-[family-name:var(--font-family-display)] text-4xl font-normal tracking-[-0.04em] text-[var(--color-content-primary)] sm:text-6xl">
          Maps, charts, and tables for every way you move
        </h1>
        <p className="mb-10 max-w-3xl text-lg text-[var(--color-content-secondary)] sm:text-xl">
          Explore running, biking, skiing, paddling, swimming, and more in a visual workspace that
          adapts to the question, not just the sport.
        </p>
        <a href={getStravaAuthUrl()}>
          <img src={stravaLoginButton} alt="Connect with Strava" className="h-12" />
        </a>
      </main>
    </div>
  );
}
